import get from 'lodash/get';

const PATHS = {
    profile: '/user',
};

Object.freeze(PATHS);

class UserService {
    /**
     * Should be implemented in a wrapper
     */
    static getAccessToken;

    constructor(restService) {
        this.restService = restService;
    }

    async fetchUserInfo() {
        try {
            const {
                data: {
                    data: { attributes },
                },
            } = await this.restService.get(PATHS.profile, { token: UserService.getAccessToken() });

            return Promise.resolve(attributes);
        } catch (error) {
            return this.#handleErrors(error);
        }
    }

    #handleErrors(error) {
        return Promise.reject(get(error, 'response.data.errors'));
    }
}

export default UserService;
